module.exports = __webpack_public_path__ + "static/01-1be4dd13ac65304b0fd1694efac81da3.jpg";